import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TeamsProvider } from './contexts/TeamsContext';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import MapPage from './pages/MapPage';
import AdminPage from './pages/AdminPage';
import MyBookingsPage from './pages/MyBookingsPage';
import TeamsConfigPage from './pages/TeamsConfigPage';
import TeamsAuthPopup from './pages/TeamsAuthPopup';

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  );

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
      <Route path="/bookings" element={<ProtectedRoute><MyBookingsPage /></ProtectedRoute>} />
      <Route path="/admin/*" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
      <Route path="/config" element={<TeamsConfigPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  // /auth-popup must render outside AuthProvider to avoid MSAL session interference
  if (window.location.pathname === '/auth-popup') {
    return <TeamsAuthPopup />;
  }

  return (
    <BrowserRouter>
      <TeamsProvider>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="bottom-right" richColors closeButton />
        </AuthProvider>
      </TeamsProvider>
    </BrowserRouter>
  );
}

export default App;
